import { assign, includes } from 'lodash';

import {
  getStyleType,
  STYLE_TYPES,
  SYMBOLOGY_TYPES,
  GEOJSON_GEOMETRIES
} from '../api/Styles/Styles';
import * as layerOps from '../api/Layers/layer-operations';

const getDefaultStyle = layer => {
  const styleType = layerOps.isJoin(layer)
    ? STYLE_TYPES.GEOJSON
    : getStyleType(layerOps.getSubType(layer));

  let style = { styleType };
  if (includes([STYLE_TYPES.GEOJSON, STYLE_TYPES.MAPBOX, STYLE_TYPES.ANNOTATIONS], styleType)) {
    const geometry = layerOps.getGeoJSONGeometry(layer);
    style = {
      geojsonStyle: {
        type: SYMBOLOGY_TYPES.SINGLE,
        geometry,
        styleData: { color: '#ea6512', weight: 1, alpha: 0.9 }
      }
    };
    if (geometry === GEOJSON_GEOMETRIES.POINT) {
      assign(style.geojsonStyle.styleData, {
        pointSize: 10,
        pointType: 'circleMarker'
      });
    }
  }

  if (styleType === STYLE_TYPES.RASTER) style = { rasterStyle: { opacity: 90 } };

  return style;
};

export default getDefaultStyle;
